/* AfroTropic 3D Hero v1.1 — bug fixes applied */
(function () {
  'use strict';

  function loadScript(src, cb) {
    var s = document.createElement('script');
    s.src = src; s.async = true;
    s.onload = cb || function () {};
    document.head.appendChild(s);
  }

  function initHero() {
    var heroContainer = document.querySelector('.hero__container');
    var mediaGrid     = document.querySelector('.hero__media-grid');
    if (!heroContainer || !mediaGrid) return;
    if (document.getElementById('at-vanta-bg')) return;

    /* 1. Vanta canvas — injected inside media-grid so it sits behind content-wrapper */
    var vantaEl = document.createElement('div');
    vantaEl.id = 'at-vanta-bg';
    mediaGrid.appendChild(vantaEl);

    /* 2. Dark overlay */
    var overlay = document.createElement('div');
    overlay.className = 'at-hero-overlay';
    mediaGrid.appendChild(overlay);

    /* 3. Gold floating particles — FIXED: --dur is positive, --delay is negative */
    var particles = document.createElement('div');
    particles.className = 'at-hero-particles';
    mediaGrid.appendChild(particles);
    for (var i = 0; i < 24; i++) {
      var p = document.createElement('div');
      p.className = 'at-particle';
      var sz = (Math.random() * 6 + 3).toFixed(1) + 'px';
      p.style.cssText = [
        'left:'     + (Math.random() * 96).toFixed(1) + '%',
        'width:'    + sz,
        'height:'   + sz,
        '--dur:'    + (Math.random() * 10 + 8).toFixed(1) + 's',
        '--delay:-' + (Math.random() * 14).toFixed(1) + 's'
      ].join(';');
      particles.appendChild(p);
    }

    /* 4. Scroll indicator */
    var si = document.createElement('div');
    si.className = 'at-scroll-indicator';
    si.innerHTML = '<span>SCROLL</span><div class="at-scroll-mouse"></div>';
    heroContainer.appendChild(si);

    /* 5. Three.js → Vanta FOG */
    function startVanta() {
      if (typeof VANTA === 'undefined' || !VANTA.FOG) return;
      VANTA.FOG({
        el:             '#at-vanta-bg',
        mouseControls:  true,
        touchControls:  true,
        gyroControls:   false,
        highlightColor: 0xD4A853,
        midtoneColor:   0x5C3324,
        lowlightColor:  0x0D0704,
        baseColor:      0x2C1810,
        blurFactor:     0.58,
        speed:          1.10,
        zoom:           0.90
      });
    }

    function loadVanta() {
      loadScript(
        'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.fog.min.js',
        startVanta
      );
    }

    if (typeof THREE !== 'undefined') {
      loadVanta();
    } else {
      loadScript(
        'https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js',
        loadVanta
      );
    }

    /* 6. GSAP entrance — graceful fallback if GSAP fails */
    function runGSAP() {
      if (typeof gsap === 'undefined') {
        /* Fallback: CSS transitions so text is never stuck invisible */
        heroContainer.querySelectorAll('h1,h2,p,.button,a.button').forEach(function(el){
          el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
          el.style.opacity    = '1';
          el.style.transform  = 'none';
        });
        return;
      }
      var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      var h = heroContainer.querySelector('h1, h2, [class*="heading"]');
      if (h) { gsap.set(h, { opacity:0, y:30 }); tl.to(h, { opacity:1, y:0, duration:1.0 }, 0.3); }

      var ps = heroContainer.querySelectorAll('p, .rte p');
      if (ps.length) { gsap.set(ps, { opacity:0, y:20 }); tl.to(ps, { opacity:1, y:0, duration:0.85, stagger:0.12 }, 0.68); }

      var btns = heroContainer.querySelectorAll('a.button, .button');
      if (btns.length) { gsap.set(btns, { opacity:0, y:16 }); tl.to(btns, { opacity:1, y:0, duration:0.75, stagger:0.1 }, 1.0); }
    }

    setTimeout(function() {
      if (typeof gsap !== 'undefined') { runGSAP(); return; }
      loadScript('https://cdn.jsdelivr.net/npm/gsap@3/dist/gsap.min.js', runGSAP);
    }, 200);
  }

  /* Run after DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero);
  } else {
    initHero();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(initHero, 200); });

})();
